import { motion } from 'framer-motion'

interface SectionHeaderProps {
  badge: string
  title: string
  description: string
  className?: string
  isInView?: boolean
}

export default function SectionHeader({ 
  badge, 
  title, 
  description, 
  className = '',
  isInView = true
}: SectionHeaderProps) {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 15 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: [0.22, 1, 0.36, 1] as any
      },
    },
  }

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate={isInView ? 'visible' : 'hidden'}
      className={`section-head ${className}`}
    >
      <motion.span
        variants={itemVariants}
        className="eyebrow"
      >
        {badge}
      </motion.span>
      <motion.h2
        variants={itemVariants}
        className="mt-4"
        style={{ color: 'var(--text)', letterSpacing: '-0.02em' }}
      >
        {title}
      </motion.h2>
      <motion.p
        variants={itemVariants}
        className="mt-4 text-[1.06rem]"
        style={{ color: 'var(--muted)', maxWidth: '650px', marginLeft: 'auto', marginRight: 'auto' }}
      >
        {description}
      </motion.p>
    </motion.div>
  )
}
